<template>
  <div v-if="siteFooter" class="footer">
    <div v-if="siteFooter.copyright" class="copyright">{{ siteFooter.copyright }}</div>
    <div v-if="siteFooter.tagline" class="tagline">{{ siteFooter.tagline }}</div>
  </div>
</template>

<script>

import gql from 'graphql-tag'

export default {
  name: 'Footer',
  data() {
    return {
      siteFooter: {},
      loading: 0
    }
  },
  props: [
    'id'
  ],
  apollo: {
    siteFooter: {
      query: gql`query SiteFooter ($id: ItemId) {
        siteFooter (filter: {id: {eq: $id}}) {
          tagline
          copyright
        }
      }`,
      loadingKey: 'loading',
      variables() {
        return {
          id: this.id
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/assets/styles/breakpoints.less";

.footer {
  background-color: #FFFFFF;
  font-family: Helvetica,Arial,sans-serif !important;
  font-size: 14px;
  margin-top: 10px;
  padding: 10px 20px;
  display: flex;
  flex-wrap: wrap-reverse;
  align-items: center;

  & .copyright {
    color: #959595;
    font-size: 13px;
    flex: 1;
  }

  & .tagline {
    font-family: LeagueGothicRegular;
    font-size: 20px;
    text-transform: uppercase;
  }
}

@media @for-phone {
  .footer {
    text-align: center;
    
    & .tagline {
      font-size: 17px;
      width: 100%;
    }
  }
}
</style>
